export const DAYS_LIST: { text: string; value: string }[] = [
  { text: 'Monday', value: 'MONDAY' },
  { text: 'Tuesday', value: 'TUESDAY' },
  { text: 'Wednesday', value: 'WEDNESDAY' },
  { text: 'Thursday', value: 'THURSDAY' },
  { text: 'Friday', value: 'FRIDAY' },
  { text: 'Saturday', value: 'SATURDAY' },
  { text: 'Sunday', value: 'SUNDAY' }
];
